import React, { lazy } from 'react'
import ComponentLoader from './component-loader'
import { Navigate } from 'react-router-dom'
import UnAuthorizeLayout from 'screens/unauthorize/unauthorize-layout'

// T78: routes for a pending (not-yet-activated) merchant. Uses the minimal
// unauthorize layout — pending merchants must not reach the full admin shell.
const PendingApproval = ComponentLoader(
  lazy(() => import('screens/unauthorize/pending-approval'))
)

const PendingRoutes = [
  {
    path: '',
    element: <UnAuthorizeLayout />,
    children: [
      {
        path: '/pending',
        index: true,
        element: <PendingApproval />,
      },
      {
        path: '',
        index: true,
        element: <Navigate replace to={'/pending'} />,
      },
      {
        path: '*',
        index: true,
        element: <Navigate replace to={'/pending'} />,
      },
    ],
  },
]

export default PendingRoutes
